import createAxios from "./axiosHttp";

function getEvents(pagination, query, sort) {
  const axios = createAxios();
  const urlPath = "ttmm/ttmm_events/ql";
  return axios.post(urlPath, { pagination, query, sort });
}

function exportar(pagination, query, sort) {
  const axios = createAxios();
  const urlPath = "ttmm/ttmm_events/ql/export";
  return axios.post(
    urlPath,
    { pagination, query, sort },
    { responseType: "arraybuffer" }
  );
}

function getEventById(event_id) {
  const axios = createAxios();
  const urlPath = `ttmm/ttmm_events/${event_id}`;
  return axios.get(urlPath);
}

function getAllEvents() {
  const axios = createAxios();
  const urlPath = "ttmm/ttmm_events";
  return axios.get(urlPath);
}

function createEvent(body) {
  const axios = createAxios();
  const urlPath = "ttmm/ttmm_events";
  return axios.post(urlPath, body);
}

function updateEvent(body, event_id) {
  const axios = createAxios();
  const urlPath = `ttmm/ttmm_events/${event_id}`;
  return axios.put(urlPath, body);
}

function deleteEvent(event_ids) {
  const axios = createAxios();
  const urlPath = `ttmm/ttmm_events/${event_ids}`;
  return axios.delete(urlPath);
}

export const eventService = {
  getEvents,
  exportar,
  getEventById,
  getAllEvents,
  createEvent,
  updateEvent,
  deleteEvent,
};
